import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d94aeec8")

_pushScopeId("data-v-d94aeec8")
const _hoisted_1 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "Die folgende Ansicht wird geteilt:")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "Url:")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GenericDialog = _resolveComponent("GenericDialog")

  return (_openBlock(), _createBlock(_component_GenericDialog, {
    header_text: "Ansicht teilen",
    onClose: _ctx.close,
    max_width: "800px"
  }, {
    default: _withId(() => [
      _hoisted_1,
      _withDirectives(_createVNode("textarea", {
        readonly: "",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.stateJson = $event)),
        rows: "4"
      }, null, 512), [
        [_vModelText, _ctx.stateJson]
      ]),
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _withDirectives(_createVNode("textarea", {
        readonly: "",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.shareUrl = $event)),
        rows: "4"
      }, null, 512), [
        [_vModelText, _ctx.shareUrl]
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})